import { render, staticRenderFns } from "./TripHotelListItem.vue?vue&type=template&id=50bf61a4&scoped=true&"
import script from "./TripHotelListItem.vue?vue&type=script&lang=js&"
export * from "./TripHotelListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripHotelListItem.vue?vue&type=style&index=0&id=50bf61a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf61a4",
  null
  
)

export default component.exports